<template>
    <svg
        class="icon-tick"
        viewBox="0 0 16 13"
        xmlns="http://www.w3.org/2000/svg"
    ><path d="M5.09,10.28,1.27,6.21,0,7.57,5.09,13,16,1.36,14.73,0Z" /></svg>
</template>